export const translations = {
	en: {
		title: 'Dodo Icons',
		subtitle: 'Icons for building beautiful interfaces',
		figmaLink: 'Figma',
		pluginLink: 'Plugin',
		githubLink: 'GitHub',
		searchPlaceholder: 'Search icons...',
		clearSearch: 'Clear search',
		iconsCount: 'icons',
		iconsOf: 'of',
		noIconsFound: 'No icons found',
		tryDifferentSearch: 'Try a different search term or adjust filters',
		copied: 'Copied!',
		copyIcon: 'Copy',
		// Filter keys
		filterByStyle: 'Filter by style',
		filled: 'Filled',
		outlined: 'Outlined',
		other: 'Other',
		clearAllFilters: 'Clear all',
		// Sound
		enableSound: 'Enable sound',
		disableSound: 'Disable sound',
	},
	ru: {
		title: 'Dodo Icons',
		subtitle: 'Иконки для\u00A0потрясающих интерфейсов',
		figmaLink: 'Figma',
		pluginLink: 'Плагин',
		githubLink: 'GitHub',
		searchPlaceholder: 'Поиск иконок...',
		clearSearch: 'Очистить поиск',
		iconsCount: 'иконок',
		iconsOf: 'из',
		noIconsFound: 'Иконки не\u00A0найдены',
		tryDifferentSearch: 'Попробуйте изменить запрос или\u00A0фильтры',
		copied: 'Скопировано!',
		copyIcon: 'Копировать',
		// Filter keys
		filterByStyle: 'Фильтр по\u00A0стилю',
		filled: 'Заливка',
		outlined: 'Контур',
		other: 'Прочие',
		clearAllFilters: 'Сбросить всё',
		// Sound
		enableSound: 'Включить звук',
		disableSound: 'Выключить звук',
	},
} as const;

export type Locale = keyof typeof translations;
export type TranslationKey = keyof (typeof translations)['en'];
